<template>
  <div>
    <sidebar :position="longitudeSideBarPosition" :size="longitudeSideBarSize" :isOpen="isOpen" :direction="'right'">
      <template slot="content">
        <div style="padding-top: 5px">
          <div style="background-color: white; border-radius: 5px 5px 5px 5px; width: 170px">
            <template v-if="longitude!=null">
              <h3 class="ui center aligned header" style="padding-top: 3px;padding-bottom: 3px">
                {{longitude.deg}}<sup>o</sup>{{" " + longitude.min}}<sup>'</sup>
                {{" " + longitude.sec}}<sup>''</sup>{{" " + longitude.dir}}
              </h3>
            </template>
          </div>
        </div>
      </template>
    </sidebar>
    <sidebar :position="latitudeSideBarPosition" :size="latitudeSideBarSize" :isOpen="isOpen" :direction="'bottom'">
      <template slot="content">
        <div style="padding-top: 5px;padding-bottom: 35px">
          <div style="background-color: white; border-radius: 5px 5px 5px 5px">
            <template v-if="latitude!=null">
              <h3 class="ui center aligned header" style="padding-top: 3px;padding-bottom: 3px">
                {{latitude.deg}}<sup>o</sup>{{" " + latitude.min}}<sup>'</sup>{{" " + latitude.sec}}<sup>''</sup>{{" " +
                latitude.dir}}
              </h3>
            </template>
          </div>
        </div>
      </template>
    </sidebar>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Sidebar from '@/components/sidebar/sidebar'

  import {convertDDToDMS, addViewerEventListener} from '@/utils/cesiumUtils'

  export default {
    name:"coordinates-viewer",
    //передоваемые параметры
    props: {
      cesiumObject: {
        type: String,
        default: 'default'
      }
    },
    // локальное состояние
    data() {
      return {
        longitudeSideBarPosition: {
          top: 0,
          left: 0,
          right: 1,
          bottom: 100
        },
        longitudeSideBarSize: {
          width: '200px',
          height: '31px'
        },
        latitudeSideBarPosition: {
          top: 0,
          left: 0,
          right: 230,
          bottom: 65
        },
        latitudeSideBarSize: {
          width: '170px',
          height: '70px'
        },
        longitude: null,
        latitude: null,
        isOpen: false
      }
    },
    mounted() {
      this.setMouseEventsListener();
    },

    //вычисляемые свойства (https://ru.vuejs.org/v2/guide/computed.html#Вычисляемые-свойства)
    computed: {},
    //Методы для изменения локального состояния.Ограничения (https://ru.vuejs.org/v2/guide/list.html#Отслеживание-изменений-в-массивах)
    methods: {
      setMouseEventsListener() {
        const viewer = this.getCesium(this.cesiumObject).viewer;
        if (viewer != null) {
          addViewerEventListener(viewer, 'mousemove', (lat, lng) => {
            if (lat === null || lng === null) {
              this.isOpen = false;
            }
            else {
              this.latitude = convertDDToDMS(lat, false);
              this.longitude = convertDDToDMS(lng, true);
              this.isOpen = true;
            }
          });
        }
      },

      getCesium() {
        return window.cesiumViewer[this.cesiumObject];
      }
    },

    components: {Sidebar}
  }
</script>

<style scoped>

</style>
